import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage,
    TibboDataType, ValidationMessageType, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_06 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_06';
        this.name = 'Tibbit 06';
        this.lines = 2;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
